import React from 'react';

import {useDocumentViewer} from '../../context/DocumentViewerContext';

import DocumentContent from './DocumentContent';
import DocumentHeader from './DocumentHeader';

export default function DocumentViewer() {
    const { currentDocument } = useDocumentViewer();
    
    if (!currentDocument) return null;
    
    const { fileName, sheetName, downloadLink } = currentDocument;

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <DocumentHeader fileName={fileName} sheetName={sheetName} downloadLink={downloadLink} />
            <DocumentContent documentUrl={downloadLink} />
        </div>
    );
}
